/**
 * Botão discreto no header da loja.
 * @param {{ onClick: () => void, disabled?: boolean }} props
 */
export function DocumentOrderEntryButton({ onClick, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Pedir por nota ou lista"
      title="Pedir por nota ou lista"
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-zinc-200 text-zinc-600 transition hover:border-[rgb(var(--st-rgb)/0.4)] hover:bg-[rgb(var(--st-rgb)/0.08)] hover:text-[var(--st-700)] disabled:opacity-40 sm:h-10 sm:w-10 dark:border-zinc-600 dark:text-zinc-300 dark:hover:border-[rgb(var(--st-rgb)/0.35)] dark:hover:bg-zinc-800/90 dark:hover:text-[var(--st-400)]"
    >
      <svg className="h-[18px] w-[18px] sm:h-5 sm:w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
        <path d="M9 12h6M9 16h6M7 4h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 4v5h5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
